/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CRMCHLink,
} from '../models/index';
import {
    CRMCHLinkFromJSON,
    CRMCHLinkToJSON,
} from '../models/index';

export interface GetCRMCHDirectLODLinkRequest {
    brUUID: string;
}

/**
 * 
 */
export class CRMCHLinkApi extends runtime.BaseAPI {

    /**
     * Creates request options for getCRMCHDirectLODLink without sending the request
     */
    async getCRMCHDirectLODLinkRequestOpts(requestParameters: GetCRMCHDirectLODLinkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUUID'] == null) {
            throw new runtime.RequiredError(
                'brUUID',
                'Required parameter "brUUID" was null or undefined when calling getCRMCHDirectLODLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/crmchLink/{brUUID}`;
        urlPath = urlPath.replace(`{${"brUUID"}}`, encodeURIComponent(String(requestParameters['brUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns CRM CH LOD direct link for the given business relationship
     */
    async getCRMCHDirectLODLinkRaw(requestParameters: GetCRMCHDirectLODLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CRMCHLink>> {
        const requestOptions = await this.getCRMCHDirectLODLinkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CRMCHLinkFromJSON(jsonValue));
    }

    /**
     * Returns CRM CH LOD direct link for the given business relationship
     */
    async getCRMCHDirectLODLink(requestParameters: GetCRMCHDirectLODLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CRMCHLink> {
        const response = await this.getCRMCHDirectLODLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
